export default __webpack_public_path__ + "static/media/No.6-6.c99ab481.jpg";